// @ts-nocheck
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CheckboxPresentationProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface ResultCountProps {
    wrapper?: InjectableCss;
    bottomWrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
    selectAll?: CheckboxPresentationProps;
}

const wrapperProps = (side: "top" | "bottom"): InjectableCss => ({
    css: css`
        ${({ theme }) => css`
            ${side === "top"
                ? spacingStyles(null, theme.design.typography.spacing.base)
                : spacingStyles(theme.design.typography.spacing.base, null)}
        `}

        display: flex;
        flex-flow: row wrap;
        align-items: flex-end;
        justify-content: space-between;
        row-gap: 0.2em;
        font-size: ${x => x.theme.design.typography.size.smaller};

        &::before {
            content: "";
        }
    `,
});

export const resultCountProps: ResultCountProps = {
    wrapper: wrapperProps("top"),
    bottomWrapper: wrapperProps("bottom"),
    countText: {
        css: css`
            flex-grow: 1;
            white-space: nowrap;
            margin: 0 1em;

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        `,
    },
    selectAll: {
        sizeVariant: "small",
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css as any}
            ${inlineSeparatorStyles({ spacing: pxToRem(23) })}
            cursor: pointer;

            @media print {
                display: none;
            }
        `,
    },
};
